//import Libraries
import React, {Component} from 'react';
import { connect } from 'react-redux';

//import Components
import Layout from '../../hoc/Layout/Layout'
import Fullpage from '../../hoc/Fullpage/Fullpage';
import TitleSection from '../../components/TitleSection/TitleSection';
import Blog from './Blog/Blog';
import {titles} from '../../language/language.json';

import * as communityActions from './actions/communityActions';
import * as modalActions from '../../components/Navigation/actions/modalActions'

//import Style classes
import './Community.css';

class Community extends Component
{
    constructor(props) {
        super(props);

        const {firstName, lastName, email} = this.props.user;

        let fullName = lastName ? lastName : '';
        fullName += firstName ? firstName : '';

        this.state = {
            name : fullName,
            mail : email ? email : '',
            message : '',
        }
    }

    componentDidMount(){
        this.props.onLoadArticles();
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    reset = () => {
        this.setState({
            name : '',
            mail : '',
            message : ''
        })
    }

    isInputValid = () => {
        return this.state.name !== '' && 
               this.state.mail !== '' && 
               this.state.message !== '';
    }

    render() {
        if(!this.props.community.articles) {
            return (
                <Layout isStore={false} relative={true}>
                </Layout>
            )
        }

        return (
            <Layout isStore={false} relative={true}>
                <div id="Notice" className="Notice">
                    <Blog articles={this.props.community.articles}/>
                </div>
                <TitleSection data={titles.Contact} lang={this.props.universal.language} />
                <Fullpage id="Contact" className="Contact" padding="20px 70px 70px 70px" height=" ">
                    <div className="ContactImage">
                        <img src={require("../../assets/greenhouse/greenhouse-0.jpg")} alt="" />
                    </div>
                    <div className="ContactForm">
                        <input type="text" name="name" placeholder="성함" value={this.state.name} onChange={this.handleOnChange} />
                        <input type="text" name="mail" placeholder="example@email.com" value={this.state.mail} onChange={this.handleOnChange} />
                        <textarea rows="5" name="message" placeholder="메세지를 입력해주세요" value={this.state.message} onChange={this.handleOnChange} />
                        <input 
                            type="submit" 
                            value={{"en": "Send" , "ko": "보내기"}[this.props.universal.language]} 
                            onClick={() => {
                                this.props.onSendContact(this.state, {
                                    successFunc : () => this.props.onToggleModal('contactSent')
                                })
                                this.setState({
                                    message : ''
                                })
                            }} 
                            disabled={!this.isInputValid()}
                        />
                        <input type="submit" value={{"en": "Rest" , "ko": "모두 지우기"}[this.props.universal.language]} onClick={this.reset} />
                    </div>
                </Fullpage>
            </Layout>
        )
    }

}

const mapStateToProps = (state) => {
    return { 
        universal: state.universal,
        user : state.user,
        community : state.community,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSendContact : (datas, funcs) => {
            dispatch(communityActions.sendContact(datas, funcs))
        },
        onLoadArticles : () => {
            dispatch(communityActions.loadArticles());
        },
        onToggleModal : (name) => {
            dispatch(modalActions.toggleModal(name));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Community);



// WEBPACK FOOTER //
// ./src/pages/Community/Community.js